import { render, staticRenderFns } from "./IconSmileSad.vue?vue&type=template&id=10443d22&"
import script from "./IconSmileSad.vue?vue&type=script&lang=js&"
export * from "./IconSmileSad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports